import React from 'react';
import { X } from 'lucide-react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  newSlideIndex: string;
  setNewSlideIndex: (value: string) => void;
  onCreateSlide: () => void;
  isCreatingSlide: boolean;
  maxEnabledSlideIndex: number;
};

export const CreateSlideModal: React.FC<Props> = ({
  isOpen,
  onClose,
  newSlideIndex,
  setNewSlideIndex,
  onCreateSlide,
  isCreatingSlide,
  maxEnabledSlideIndex
}) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        {/* 模态框头部 */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">新建幻灯片</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        
        {/* 模态框内容 */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              幻灯片序号
            </label>
            <input
              type="number"
              min="0"
              max="999"
              value={newSlideIndex}
              onChange={(e) => setNewSlideIndex(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="请输入幻灯片序号"
              autoFocus
            />
            <p className="mt-1 text-xs text-gray-500">
              当前最大幻灯片序号: {maxEnabledSlideIndex}
            </p>
          </div>
        </div>
        
        {/* 模态框底部 */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors text-sm"
            disabled={isCreatingSlide}
          >
            取消
          </button>
          <button
            onClick={onCreateSlide}
            className={`px-4 py-2 rounded-md transition-colors text-sm font-medium ${
              isCreatingSlide
                ? 'bg-blue-100 text-blue-600 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
            disabled={isCreatingSlide}
          >
            {isCreatingSlide ? '创建中...' : '创建'}
          </button>
        </div>
      </div>
    </div>
  );
};
